import { LoadingImageUrl } from '@/constants';
import React from 'react';
import { STATISTICS_DATA, STATISTICS_DATA_HERO } from '../../constants';
import * as styles from './index.module.less';

interface IProps {
  isRotateLine?: boolean;
  isHeroBanner?: boolean;
}

const Statistics = ({ isRotateLine = false, isHeroBanner = false }: IProps) => {
  return (
    <div className={styles.wrapper}>
      {(isHeroBanner ? STATISTICS_DATA_HERO : STATISTICS_DATA).map((item, index) => {
        return (
          <div key={index} className={styles.data_item}>
            <img className={`lozad ${styles.data_img}`} src={LoadingImageUrl} data-src={item.src} alt={item.alt} />
            {index !== STATISTICS_DATA.length - 1 && (
              <div className={`${styles.upright_line} ${isRotateLine ? styles.rotate_line : ''}`}></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Statistics;
